module.exports = __webpack_public_path__ + "static/media/check-solid.ba93a663.svg";